import { request } from '@vtx/utils';

export const getInfo = async (id, urlHead) => {
    const res = await request.get(
        `/cloud/${urlHead ? urlHead : 'gas'}/api/v1/homeSecurityCheckRecord/get`,
        {
            body: {
                id,
            },
        },
    );
    if (res?.result === 0) {
        const data = res?.data || {};
        return {
            ...data,
            configList: JSON.parse(data.checkProjectDetailJson || '[]'),
        };
    }
    return {};
};

export const fetchBatchApprove = async (body, urlHead) => {
    const res = await request.get(
        `/cloud/${urlHead ? urlHead : 'gas'}/api/v1/homeSecurityCheckRecord/batchApprove`,
        {
            body,
        },
    );
    return res?.result === 0;
};
